<template>
    <!--
        use_existing_test:
        * プロジェクトインポートするかどうか
    -->
    <fieldset v-if="showUseExistingTestOpt" id="doImport">
        <legend>プロジェクトインポート</legend>
        <div>
            テスト実行時に、最新のテストランを使用するかを選択してください。
        </div>
        <div class="form-area">
            <input type="radio" class="input-radio" id="notSyncRadio" v-model="selectedSync" name="syncRadio"
                :value="false" @change="updateOpt">
            <label for="notSyncRadio">プロジェクトインポートしない: インポート済みのテストランを実行します。</label><br>
            <input type="radio" class="input-radio" id="syncRadio" v-model="selectedSync" name="syncRadio" :value="true"
                @change="updateOpt" checked>
            <label for="syncRadio">プロジェクトインポートする: テストランをインポートして実行します。(推奨)</label><br>
        </div>
    </fieldset>

    <!-- 
        sync:
        * use_existing_testオプションを選択できないコマンドの時(show_testrun系) => 常にこのフォームを表示
        * use_existing_testオプションを選択できるコマンドの時(testrun系) => そのオプションを使用しない時、このフォームを表示
    -->
    <fieldset v-if="!showUseExistingTestOpt || selectedSync" id="sync">
        <legend>プロジェクトインポートフォルダ（推奨）</legend>
        <div>
            プロジェクトインポートするSyncフォルダのパスを入力してください。<br>
            エクスプローラーからパスをコピーし、入力フォームにそのままペーストしてください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. オプションに指定するSyncフォルダ名は変更しても問題ありません。<br>
            2. Syncフォルダの作成に関しては、
            <a href="https://service.valtes.co.jp/t-dash/function/tutorial/import_export_projectfiles_vol_002"
                target="_blank">プロジェクトエクスポートのチュートリアル</a>
            を参照してください。<br>
            3. 何も入力しなかった場合、コマンドライン実行用プロジェクトフォルダ配下のreportsフォルダに出力されます。<br>
            <span style="margin-left: 18px;"></span>※コマンドライン実行用プロジェクトキー<br>
            <span style="margin-left: 18px;"></span>・Webアプリ用 :「commandlinetestrun」<br>
            <span style="margin-left: 18px;"></span>・Windowsアプリ用 :「commandlinetestpjwin」<br>
            <span style="margin-left: 18px;"></span>・モバイルアプリ用 :「commandlinetestpjmob」
        </div>
        <div class="form-area">
            <label for="syncPath">・プロジェクトインポートするSyncフォルダのパス</label>
            <PathHelp /><br>
            <input if="syncPath" type=" text" class="input-text" id="syncFolderShowTestrun" v-model="inputedSync"
                name="syncFolderShowTestrun" @input="updateOpt" placeholder="/Path/to/your_sync">
        </div>
    </fieldset>
</template>

<script>
import { onMounted, ref } from 'vue';

import strUtils from '@/js/strUtils';
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'SyncForm',
    props: ["showUseExistingTestOpt"],
    setup(props, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedSync = ref("")
        const selectedSync = ref(true)

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            let createdOpt = ""

            // Syncインポート
            if (!selectedSync.value && props.showUseExistingTestOpt) {
                createdOpt += " --use_existing_test"
            } else {
                if (inputedSync.value) {
                    inputedSync.value = await strUtils.replaceSlush(inputedSync.value)
                    createdOpt += ` --sync ${inputedSync.value}`
                }
            }

            // cacheに保存
            await cacheUtils.saveData("syncNotUseExistingTest", selectedSync.value)
            await cacheUtils.saveData("syncDir", inputedSync.value)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "sync", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            selectedSync.value = await cacheUtils.getData("syncNotUseExistingTest", true)
            inputedSync.value = await cacheUtils.getData("syncDir")

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedSync,
            selectedSync,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
